import React from 'react';
import contractorAction from '../../actions/contractorAction';

class ModalStaff extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.state = {
            oldStaffId: "",
            newStaffId: "",
            warningMsg: "",
        };
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
    };

    componentDidMount() {

    }
    handleClick(e) {

        if (this.props.processing) return;
        if (this.state.newStaffId == "" || this.state.oldStaffId == "")
            return this.setState({ warningMsg: "Staff cannot be emptied" });
            
        contractorAction.processing(true);
        contractorAction.replaceStaff(this.state.oldStaffId, this.state.newStaffId);
        this.modalClose();
    }
    modalClose() {
        this.props.shouldModalClose(false);
    }

    handleEdit(e) {

        let index = parseInt(e.target.getAttribute('data-index'));
        let value = e.target.value;
        if (index == 0) {
            this.setState({ oldStaffId: value });
        } else {
            this.setState({ newStaffId: value });
        }
    }
    renderStaffs() {
        return this.props.staffs.map((staff, index) => {
            return (
                <option value={staff.staffId} key={index}>{staff.userName}</option>
            );
        });
    }

    renderContent() {
        let body = "";

        body = (
            <div>
                <form className="form-horizontal atd-i-wp">
                    <label htmlFor="oldStaff" className="col-xs-4 control-label">From: </label>
                    <div className="input-group input-group-sm">
                        <select className="form-control atd-sel" name="oldStaff" data-index="0" onChange={this.handleEdit} value={this.state.oldStaffId}>
                            <option value="" ></option>
                            {this.renderStaffs()}
                        </select>
                    </div>
                </form>
                <form className="form-horizontal atd-i-wp">
                    <label htmlFor="newStaff" className="col-xs-4  control-label">Replace To: </label>
                    <div className="input-group input-group-sm">
                        <select className="form-control atd-sel" name="newStaff" data-index="1" onChange={this.handleEdit} value={this.state.newStaffId}>
                            <option value="" ></option>
                            {this.renderStaffs()}
                        </select>
                    </div>
                </form>
            </div>
        );

        return body;
    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;

        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="report-modal" style={{ visibility: style.visibility }}>
                    <div className="modal-header">
                        <h4 className="modal-title" >Replace Employee Duty</h4>
                    </div>

                    <div className="modal-body" >
                        <div className="warning">{this.state.warningMsg}</div>
                        {this.renderContent()}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-warning" onClick={this.handleClick}>Replace</button>
                        <button type="button" className="btn btn-default" onClick={this.modalClose}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default ModalStaff;


// WEBPACK FOOTER //
// ./app/setComponents/contractorComponents/modalStaff.js